import {
  AffiliationHeadRoleIds,
  AllAffiliationRoleIds,
  AllManagerRoleIds,
  BASIC_TEACHER_ROLE_IDS,
  ManageAffiliationUsersRoleIds,
  SCHOOL_PARTNER_RM_IDS,
} from "@/constants/userRoles";
import { AffiliationSelectorStateEnum } from "@/enums/affiliation";
import { TeacherRoleIdsEnum } from "@/enums/userManagement";
import { RouteLocationNormalized, RouteRecordRaw } from "vue-router";
export default [
  {
    path: "/affiliation/dashboard",
    component: () =>
      import(
        /* webpackChunkName: 'AffiliationDashboard' */ "@/views/affiliation/AffiliationDashboard.vue"
      ),
    name: "AffiliationDashboard",
    meta: {
      requiresAuth: true,
      scrollToTop: true,
      allowedRoleIds: AffiliationHeadRoleIds,
      showAffiliationSelector: AffiliationSelectorStateEnum.ENABLED,
    },
  },
  {
    path: "/affiliation/teacher-dashboard",
    component: () =>
      import(/* webpackChunkName: 'TeacherDashboard' */ "@/views/affiliation/TeacherDashboard.vue"),
    name: "TeacherDashboard",
    meta: {
      requiresAuth: true,
      scrollToTop: true,
      // BASIC_TEACHER (32) lands here — it is the only dashboard in its navbar config.
      allowedRoleIds: AllAffiliationRoleIds.concat(BASIC_TEACHER_ROLE_IDS),
    },
  },
  {
    path: "/affiliation/interactions-dashboard",
    component: () =>
      import(
        /* webpackChunkName: 'InteractionsDashboard' */ "@/views/affiliation/InteractionsDashboard.vue"
      ),
    name: "InteractionsDashboard",
    meta: {
      requiresAuth: true,
      scrollToTop: true,
      allowedRoleIds: AllAffiliationRoleIds.concat(AllManagerRoleIds),
      showAffiliationSelector: AffiliationSelectorStateEnum.ENABLED,
    },
  },
  {
    path: "/affiliation/my-profile",
    component: () =>
      import(
        /* webpackChunkName: 'AffiliationProfile' */ "@/views/affiliation/AffiliationProfile.vue"
      ),
    name: "AffiliationProfile",
    meta: {
      requiresAuth: true,
      scrollToTop: true,
      allowedRoleIds: AllAffiliationRoleIds,
      showAffiliationSelector: AffiliationSelectorStateEnum.ENABLED,
    },
  },
  {
    path: "/affiliation/report-effort-analysis",
    component: () =>
      import(
        /* webpackChunkName: 'ReportBatchEffortAnalysis' */ "@/views/affiliation/ReportBatchEffortAnalysis.vue"
      ),
    name: "ReportBatchEffortAnalysis",
    meta: {
      requiresAuth: true,
      scrollToTop: true,
      allowedRoleIds: AllAffiliationRoleIds.concat(
        AllManagerRoleIds,
        SCHOOL_PARTNER_RM_IDS,
        BASIC_TEACHER_ROLE_IDS,
      ),
      showAffiliationSelector: AffiliationSelectorStateEnum.ENABLED,
    },
  },
  {
    path: "/affiliation/report-batch-performance",
    component: () =>
      import(
        /* webpackChunkName: 'ReportBatchPerformance' */ "@/views/affiliation/ReportBatchPerformance.vue"
      ),
    name: "ReportBatchPerformance",
    meta: {
      requiresAuth: true,
      scrollToTop: true,
      allowedRoleIds: AllAffiliationRoleIds.concat(
        AllManagerRoleIds,
        SCHOOL_PARTNER_RM_IDS,
        BASIC_TEACHER_ROLE_IDS,
      ),
      showAffiliationSelector: AffiliationSelectorStateEnum.ENABLED,
    },
  },
  {
    path: "/affiliation/report-student-progress",
    component: () =>
      import(
        /* webpackChunkName: 'ReportStudentProgress' */ "@/views/affiliation/ReportStudentProgress.vue"
      ),
    name: "ReportStudentProgress",
    meta: {
      requiresAuth: true,
      scrollToTop: true,
      allowedRoleIds: AllAffiliationRoleIds.concat(AllManagerRoleIds, SCHOOL_PARTNER_RM_IDS),
      showAffiliationSelector: AffiliationSelectorStateEnum.ENABLED,
    },
  },
  {
    path: "/affiliation/report-syllabus-coverage",
    component: () =>
      import(
        /* webpackChunkName: 'ReportSyllabusCoverage' */ "@/views/affiliation/ReportSyllabusCoverage.vue"
      ),
    name: "ReportSyllabusCoverage",
    meta: {
      requiresAuth: true,
      scrollToTop: true,
      allowedRoleIds: AllAffiliationRoleIds.concat(AllManagerRoleIds, SCHOOL_PARTNER_RM_IDS),
      showAffiliationSelector: AffiliationSelectorStateEnum.ENABLED,
    },
  },
  {
    path: "/affiliation/report-test-analysis",
    component: () =>
      import(
        /* webpackChunkName: 'ReportBatchTestAnalysis' */ "@/views/affiliation/ReportBatchTestAnalysis.vue"
      ),
    name: "ReportBatchTestAnalysis",
    meta: {
      requiresAuth: true,
      scrollToTop: true,
      allowedRoleIds: AllAffiliationRoleIds.concat(AllManagerRoleIds, SCHOOL_PARTNER_RM_IDS),
      showAffiliationSelector: AffiliationSelectorStateEnum.ENABLED,
    },
  },
  {
    path: "/affiliation/activity-report/:activityId",
    component: () =>
      import(/* webpackChunkName: 'ActivityReport' */ "@/views/affiliation/ActivityReport.vue"),
    name: "ActivityReport",
    props: (route: RouteLocationNormalized) => ({ activityId: Number(route.params.activityId) }),
    meta: {
      requiresAuth: true,
      scrollToTop: true,
      allowedRoleIds: AllAffiliationRoleIds.concat(AllManagerRoleIds),
    },
  },
  {
    path: "/affiliation/evaluate-subjective-questions",
    component: () =>
      import(
        /* webpackChunkName: 'EvaluateSubjectiveQuestions' */ "@/views/affiliation/EvaluateSubjectiveQuestions.vue"
      ),
    name: "EvaluateSubjectiveQuestions",
    meta: {
      requiresAuth: true,
      scrollToTop: true,
      allowedRoleIds: AllAffiliationRoleIds.concat(AllManagerRoleIds),
      showAffiliationSelector: AffiliationSelectorStateEnum.ENABLED,
    },
  },
  {
    path: "/affiliation/create-live-class",
    component: () =>
      import(/* webpackChunkName: 'CreateLiveClass' */ "@/views/affiliation/CreateLiveClass.vue"),
    name: "CreateLiveClass",
    meta: {
      requiresAuth: true,
      scrollToTop: true,
      allowedRoleIds: AllAffiliationRoleIds.concat(AllManagerRoleIds),
    },
  },
  {
    path: "/affiliation/institute-test-offline",
    component: () =>
      import(
        /* webpackChunkName: 'InstituteTestOffline' */ "@/views/affiliation/InstituteTestOffline.vue"
      ),
    name: "InstituteTestOffline",
    meta: {
      requiresAuth: true,
      scrollToTop: true,
      allowedRoleIds: AllAffiliationRoleIds.concat(AllManagerRoleIds),
      showAffiliationSelector: AffiliationSelectorStateEnum.ENABLED,
    },
  },
  {
    path: "/affiliation/manage-batches",
    component: () =>
      import(/* webpackChunkName: 'ManageBatches' */ "@/views/affiliation/ManageBatches.vue"),
    name: "ManageBatches",
    meta: {
      requiresAuth: true,
      scrollToTop: true,
      allowedRoleIds: ManageAffiliationUsersRoleIds.concat(AllManagerRoleIds),
      showAffiliationSelector: AffiliationSelectorStateEnum.ENABLED,
    },
  },
  {
    path: "/affiliation/manage-users",
    component: () =>
      import(/* webpackChunkName: 'ManageUsers' */ "@/views/affiliation/ManageUsers.vue"),
    name: "ManageUsers",
    meta: {
      requiresAuth: true,
      scrollToTop: true,
      // usermgmt-8-4 (OQ-37) — widened to affiliation admins (21–27) + internal admin (41) via a
      // dedicated array (NOT AllManagerRoleIds, which gates other features). OQ-44 affiliation
      // scoping (any vs own) is handled by the ENABLED affiliation selector below.
      // HotFix teacher-manage-users-access: School Teacher (31) is admitted at the route level
      // only — the shared arrays gate other features and must not be widened. The view already
      // hides Bulk Add / Move / Reset Passwords behind IsAdminRole (41), so 31 gets read + Add
      // User only.
      allowedRoleIds: ManageAffiliationUsersRoleIds.concat(AllManagerRoleIds, [
        TeacherRoleIdsEnum.SCHOOL_TEACHER,
      ]),
      showAffiliationSelector: AffiliationSelectorStateEnum.ENABLED,
    },
  },
  {
    path: "/affiliation/manage-assignments",
    component: () =>
      import(
        /* webpackChunkName: 'ManageAssignments' */ "@/views/affiliation/ManageAssignments.vue"
      ),
    name: "ManageAssignments",
    meta: {
      requiresAuth: true,
      scrollToTop: true,
      allowedRoleIds: AllAffiliationRoleIds.concat(AllManagerRoleIds),
      showAffiliationSelector: AffiliationSelectorStateEnum.ENABLED,
    },
  },
  {
    path: "/affiliation/manage-assignments/preloaded",
    component: () =>
      import(
        /* webpackChunkName: 'ManagePreloadedAssignments' */ "@/views/affiliation/ManagePreloadedAssignments.vue"
      ),
    name: "ManagePreloadedAssignments",
    meta: {
      requiresAuth: true,
      scrollToTop: true,
      allowedRoleIds: AllAffiliationRoleIds.concat(AllManagerRoleIds),
      // ENABLED is safe here: PredesignedActivities watches ActiveAffiliation and
      // resets predesignedActivitiesStore's per-course cache on a switch.
      showAffiliationSelector: AffiliationSelectorStateEnum.ENABLED,
    },
  },
  {
    path: "/affiliation/manage-assignments/questions",
    component: () =>
      import(
        /* webpackChunkName: 'ManageAssignmentQuestions' */ "@/views/affiliation/ManageAssignmentQuestions.vue"
      ),
    name: "ManageAssignmentQuestions",
    meta: {
      requiresAuth: true,
      scrollToTop: true,
      allowedRoleIds: AllAffiliationRoleIds.concat(AllManagerRoleIds),
      // DISABLED (visible, not switchable): questionSelectorStore initializes against
      // the ActiveAffiliation captured on entry, so the institute context is locked
      // while questions are being designed.
      showAffiliationSelector: AffiliationSelectorStateEnum.DISABLED,
    },
  },
  {
    path: "/affiliation/manage-assignments/create",
    component: () =>
      import(/* webpackChunkName: 'CreateAssignment' */ "@/views/affiliation/CreateAssignment.vue"),
    name: "CreateAssignment",
    meta: {
      requiresAuth: true,
      scrollToTop: true,
      allowedRoleIds: AllAffiliationRoleIds.concat(AllManagerRoleIds),
      // DISABLED (visible, not switchable): createActivityStore builds the design
      // against the ActiveAffiliation captured on entry, so the institute context is
      // locked while an activity is being created.
      showAffiliationSelector: AffiliationSelectorStateEnum.DISABLED,
    },
  },
  {
    path: "/affiliation/manage-institute-tests",
    component: () =>
      import(
        /* webpackChunkName: 'ManageInstituteTests' */ "@/views/affiliation/ManageInstituteTests.vue"
      ),
    name: "ManageInstituteTests",
    meta: {
      requiresAuth: true,
      scrollToTop: true,
      allowedRoleIds: AllAffiliationRoleIds.concat(AllManagerRoleIds),
      showAffiliationSelector: AffiliationSelectorStateEnum.ENABLED,
    },
  },
  {
    path: "/affiliation/manage-institute-tests/preloaded",
    component: () =>
      import(
        /* webpackChunkName: 'ManagePreloadedInstituteTests' */ "@/views/affiliation/ManagePreloadedInstituteTests.vue"
      ),
    name: "ManagePreloadedInstituteTests",
    meta: {
      requiresAuth: true,
      scrollToTop: true,
      allowedRoleIds: AllAffiliationRoleIds.concat(AllManagerRoleIds),
      // ENABLED is safe here: PredesignedActivities watches ActiveAffiliation and
      // resets predesignedActivitiesStore's per-course cache on a switch.
      showAffiliationSelector: AffiliationSelectorStateEnum.ENABLED,
    },
  },
  {
    path: "/affiliation/manage-institute-tests/questions",
    component: () =>
      import(
        /* webpackChunkName: 'ManageInstituteTestQuestions' */ "@/views/affiliation/ManageInstituteTestQuestions.vue"
      ),
    name: "ManageInstituteTestQuestions",
    meta: {
      requiresAuth: true,
      scrollToTop: true,
      allowedRoleIds: AllAffiliationRoleIds.concat(AllManagerRoleIds),
      // DISABLED (visible, not switchable): questionSelectorStore initializes against
      // the ActiveAffiliation captured on entry, so the institute context is locked
      // while questions are being designed.
      showAffiliationSelector: AffiliationSelectorStateEnum.DISABLED,
    },
  },
  {
    path: "/affiliation/manage-institute-tests/create",
    component: () =>
      import(
        /* webpackChunkName: 'CreateInstituteTest' */ "@/views/affiliation/CreateInstituteTest.vue"
      ),
    name: "CreateInstituteTest",
    meta: {
      requiresAuth: true,
      scrollToTop: true,
      allowedRoleIds: AllAffiliationRoleIds.concat(AllManagerRoleIds),
      // DISABLED (visible, not switchable): createActivityStore builds the design
      // against the ActiveAffiliation captured on entry, so the institute context is
      // locked while an activity is being created.
      showAffiliationSelector: AffiliationSelectorStateEnum.DISABLED,
    },
  },
  {
    path: "/affiliation/manage-live-classes",
    component: () =>
      import(
        /* webpackChunkName: 'ManageLiveClasses' */ "@/views/affiliation/ManageLiveClasses.vue"
      ),
    name: "ManageLiveClasses",
    meta: {
      requiresAuth: true,
      scrollToTop: true,
      allowedRoleIds: AllAffiliationRoleIds.concat(AllManagerRoleIds),
      showAffiliationSelector: AffiliationSelectorStateEnum.ENABLED,
    },
  },
  {
    path: "/affiliation/student-roll-numbers",
    component: () =>
      import(
        /* webpackChunkName: 'StudentRollNumbers' */ "@/views/affiliation/StudentRollNumbers.vue"
      ),
    name: "StudentRollNumbers",
    meta: {
      requiresAuth: true,
      scrollToTop: true,
      allowedRoleIds: AllAffiliationRoleIds.concat(AllManagerRoleIds),
      showAffiliationSelector: AffiliationSelectorStateEnum.ENABLED,
    },
  },
  {
    path: "/affiliation/teaching-content",
    component: () =>
      import(
        /* webpackChunkName: 'TeachingContent' */ "@/views/affiliation/TeachingContentSection.vue"
      ),
    meta: {
      requiresAuth: true,
      scrollToTop: true,
      allowedRoleIds: AllAffiliationRoleIds.concat(AllManagerRoleIds),
      showAffiliationSelector: AffiliationSelectorStateEnum.ENABLED,
    },
    children: [
      {
        path: "",
        name: "TeachingContent",
        component: () =>
          import(
            /* webpackChunkName: 'TeachingContent' */ "@/views/affiliation/TeachingContent.vue"
          ),
        meta: {
          requiresAuth: true,
          scrollToTop: true,
          allowedRoleIds: AllAffiliationRoleIds.concat(AllManagerRoleIds),
          showAffiliationSelector: AffiliationSelectorStateEnum.ENABLED,
        },
      },
      {
        path: "chapters/:subjectChapterId",
        name: "TeachingChapterDetail",
        component: () =>
          import(
            /* webpackChunkName: 'TeachingChapterDetail' */ "@/views/affiliation/TeachingChapterDetail.vue"
          ),
        meta: {
          requiresAuth: true,
          scrollToTop: true,
          allowedRoleIds: AllAffiliationRoleIds.concat(AllManagerRoleIds),
        },
      },
    ],
  },
  {
    path: "/affiliation/teacher-mapping",
    component: () =>
      import(
        /* webpackChunkName: 'AffiliationTeacherMapping' */ "@/views/affiliation/AffiliationTeacherMapping.vue"
      ),
    name: "AffiliationTeacherMapping",
    meta: {
      requiresAuth: true,
      scrollToTop: true,
      allowedRoleIds: AllAffiliationRoleIds,
      showAffiliationSelector: AffiliationSelectorStateEnum.ENABLED,
    },
  },
  {
    path: "/affiliation/implementation-score",
    component: () =>
      import(
        /* webpackChunkName: 'ImplementationScore' */ "@/views/affiliation/ImplementationScore.vue"
      ),
    name: "ImplementationScore",
    meta: {
      requiresAuth: true,
      scrollToTop: true,
      allowedRoleIds: AllAffiliationRoleIds.concat(AllManagerRoleIds),
      showAffiliationSelector: AffiliationSelectorStateEnum.ENABLED,
    },
  },
] as unknown as Array<RouteRecordRaw>;
